import { createContext, PropsWithChildren, useEffect } from 'react';
import { useApi } from '@repo-level/core-front';

import { MobileAppApi, mobileApp } from '../api';

interface MobileAppContextData {
  data?: MobileAppApi;
  error: boolean;
  pending: boolean;
}

export const MobileAppContext = createContext<MobileAppContextData>(
  null as any
);

export const MobileAppContextProvider = ({
  children,
}: PropsWithChildren<{}>) => {
  const [requestMobileApp, { error, pending, data }] = useApi(mobileApp);

  useEffect(() => {
    requestMobileApp();
  }, [requestMobileApp]);

  return (
    <MobileAppContext.Provider value={{ data, error, pending }}>
      {children}
    </MobileAppContext.Provider>
  );
};
